import { postApiCall} from "../utils/Api";

export const ListOrderTypeSummary = async (data) => {
    try {
      //console.log(data);
      const result = await postApiCall(`/api/v1/dashboard/getordertypessummary`,data,true);
      var apiresult = JSON.parse(result.data.message);
      //console.log(apiresult)
      return apiresult;
    } catch (e) {
      throw e;
    }
  };